// extracted by mini-css-extract-plugin
export default {"dialogList":"activation-subscription-modal_dialogList__FtqSQ"};